import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M27.29 21.75V11.9L14.6 6.34 1.92 11.9l12.68 5.55 11.11-4.86v9.16c-.48.27-.8.78-.8 1.37v.8c0 .87.71 1.58 1.58 1.58.87 0 1.58-.71 1.58-1.58v-.8c.01-.59-.32-1.1-.78-1.37zM14.6 12.81c-.94 0-1.7-.41-1.7-.92s.76-.92 1.7-.92 1.7.41 1.7.92c-.01.51-.76.92-1.7.92z" }, null, -1),
    _createElementVNode("path", { d: "M5.89 14.75v5.47s5.3.01 8.72 3.96c3.46-4.05 8.72-3.96 8.72-3.96v-5.47l-8.72 3.81-8.72-3.81z" }, null, -1)
  ])))
}
export default { render };